// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var $$default = {
  accessibility: {
    close: "",
    closeSubheader: "",
    newWindow: "",
    readLess: "",
    readMore: "",
    showVideosSortingOptions: "",
    sortVideoBy: ""
  },
  collection: {
    teaser: {
      more: {
        label: ""
      }
    }
  },
  common: {
    add: "",
    all_videos: "",
    confirm: "",
    download: "",
    downloadAll: "",
    edit: "",
    firstBroadcast: "",
    fskSubHeader: "",
    fskSubHeaderLink: "",
    loading: "",
    moreInfos: "",
    press: "",
    read_less: "",
    read_more: "",
    remove: "",
    save: "",
    see_more: "",
    setting: "",
    subHeader: "",
    subscribe: "",
    subscribed: ""
  },
  concert: {
    genres: {
      all: "",
      title: ""
    }
  },
  formValidation: {
    date: "",
    email: "",
    emailConfirmation: "",
    passwordConfirmation: "",
    required: ""
  },
  guide: {
    concerts: {
      soonColumnTitle: ""
    },
    dayAbbreviation: "",
    hoursMinutes: "",
    monthAbbreviation: "",
    tv: {
      daySlider: {
        dayFormat: "",
        redirectChooseDate: "",
        redirectProgram: "",
        today: "",
        tomorrow: "",
        yesterday: ""
      },
      daytime: "",
      evening: "",
      morning: ""
    }
  },
  label: {
    live: ""
  },
  mona: {
    deleteAccount: {
      description: "",
      label: "",
      title: ""
    },
    editEmail: {
      description: "",
      errorAlreadyRegistered: "",
      errorGeneric: "",
      placeholder: "",
      placeholderConfirmation: "",
      success: ""
    },
    editPassword: {
      newPasswordPlaceholder: "",
      newPasswordPlaceholderConfirmation: "",
      oldPasswordPlaceholder: "",
      success: "",
      title: ""
    },
    fsk: {
      description: "",
      title: "",
      verified16: "",
      verified18: "",
      verifybutton: ""
    },
    login: {
      emailNotVerified: "",
      footerLabel: "",
      footerLinkLabel: "",
      footerLinkUrl: "",
      forgotPassword: "",
      invalidCredentials: "",
      loginButton: "",
      loginSubtitle: "",
      noAccountButton: "",
      noAccountSubtitle: "",
      passwordPlaceholder: "",
      requestPasswordButton: "",
      requestPasswordCancelButton: "",
      requestPasswordResetButton: "",
      requestPasswordSubtitle: "",
      requestPasswordSuccessButton: "",
      requestPasswordSuccessDescription: "",
      resetPasswordButton: "",
      resetPasswordSuccessDescription: "",
      title: "",
      tvLoginDescription: "",
      tvTitle: ""
    },
    navigation: {
      disconnect: "",
      events: "",
      eventsFavorite: "",
      magazine: "",
      mona: "",
      myAccount: "",
      password: "",
      profile: "",
      tvConnection: ""
    },
    profile: {
      birthdayDayLabel: "",
      birthdayMonthLabel: "",
      birthdayTitle: "",
      birthdayYearLabel: "",
      cityPlaceholder: "",
      countryLabel: "",
      emailPlaceholder: "",
      errorMessage: "",
      firstNamePlaceholder: "",
      genderMadamValue: "",
      genderPlaceHolder: "",
      genderSirValue: "",
      lastNamePlaceholder: "",
      postCodePlaceholder: "",
      streetPlaceholder: "",
      sucessMessage: "",
      title: ""
    },
    register: {
      acceptComLabel: "",
      acceptTosLabel: "",
      confirmButton: "",
      confirmDescription: "",
      confirmSubtitle: "",
      description: "",
      nlarteLabel: "",
      passwordPlaceholderConfirmation: "",
      registerButton: "",
      title: "",
      verifyDescription: "",
      verifyFooter: "",
      verifyMainButton: "",
      verifySecondaryButton: "",
      verifySubtitle: ""
    },
    tvConnection: {
      description: ""
    },
    tvLogin: {
      ageVerificationTitle: "",
      ageVerificationDescription: "",
      ageVerificationPrimaryButton: "",
      ageVerificationSecondaryButton: "",
      ageVerifiedTitle: "",
      ageVerifiedDescription: "",
      ageVerifiedPrimaryButton: "",
      pairingDescription: "",
      pairingTitle: "",
      pairingBackButton: ""
    },
    tvAgeVerification: {
      userCheckTitle: "",
      userCheckDescription: "",
      userCheckConnectedAccountDescription: "",
      userCheckPrimaryButton: "",
      userCheckSecondaryButton: "",
      ageVerifiedDescription: "",
      ageVerifiedPrimaryButton: ""
    },
    verificationFailed: {
      buttonLabel: "",
      contactButtonLabel: "",
      contactButtonLinkUrl: "",
      contactLabel: "",
      subtitle: "",
      title: ""
    },
    verificationPending: {
      buttonLabel: "",
      subtitle: "",
      text: "",
      title: ""
    }
  },
  navbar: {
    mainNavigation: "",
    secondaryNavigation: ""
  },
  program: {
    accessible: "",
    audiodescription: "",
    available: "",
    duration: "",
    genre: "",
    in_partnership_with: "",
    live_on: "",
    next_broadcast: "",
    showOf: "",
    to_be_continued: "",
    trailer_button: "",
    vod: "",
    vod_discover: ""
  },
  search: {
    currently_loading: "",
    placeholder: "",
    search_results_for: "",
    searching: "",
    what_are_you_looking_for: ""
  },
  setting: {
    autoplayDescription: "",
    autoplayTitle: "",
    clipAutoplayDescription: "",
    clipAutoplayTitle: "",
    cookieDescription: "",
    cookieLabel: "",
    cookieTitle: "",
    playerAutoplayDescription: "",
    playerAutoplayTitle: "",
    sobrietyMessageAriaLabel: "",
    sobrietyMessageLinkLabel: "",
    sobrietyMessageLinkUrl: "",
    sobrietyMessageText: "",
    sobrietyMessageTitle: "",
    userDescription: "",
    userTargetedCommunicationDescription: "",
    userTargetedCommunicationTitle: "",
    userTitle: "",
    videoQualityDescription: "",
    videoQualityEco: "",
    videoQualityOptimal: "",
    videoQualityStandard: "",
    videoQualityTitle: ""
  },
  teaser: {
    durationUnit: ""
  },
  teasers: {
    carousel: {
      goToSlide: "",
      pause: ""
    },
    continueWatching: "",
    live: "",
    livestream: "",
    moreOptions: "",
    watch: "",
    watchLive: "",
    watchLivestream: ""
  },
  userPref: {
    message: "",
    setupCookies: ""
  },
  videos: {
    sort_by_label: ""
  }
};

exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/* No side effect */
